import Vue from 'vue';
import { Column } from '@/models/SmartTable/Column';
import { Config } from '@/models/SmartTable/Config';
import _ from 'lodash';

export default Vue.extend({
  props: {
    config: Object as () => Config,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    rows: Array as () => Array<any>
  },
  computed: {
    columns: function (): Column[] {
      if (this.config.columns) {
        const columns = this.reinitializeColumns(this.config.columns);
        return _.sortBy(
          columns.filter((c) => c.hidden === false),
          'ordering'
        );
      } else {
        // eslint-disable-next-line no-console
        console.warn('No Columns found in Config. Falling back to fields for DEBUG only..');
        return this.getObjectProperties(this.rows[0]).map(
          (c) => new Column({ title: this.capitalize(c), fieldName: c })
        );
      }
    }
  },
  methods: {
    reinitializeColumns: function (columns: Column[]): Column[] {
      return this.reorderColumns(columns);
    },
    reorderColumns: function (columns: Column[]): Column[] {
      const orderedColumns = [];
      let currentOrdering = 1;
      for (const column of _.sortBy(columns, 'ordering')) {
        column.ordering = currentOrdering;
        currentOrdering++;
        orderedColumns.push(column);
      }
      return orderedColumns;
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getObjectProperties: function (obj: any) {
      const properties = [];
      for (const prop in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, prop)) {
          properties.push(prop);
        }
      }
      return properties;
    },
    capitalize: function (s: string): string {
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
    validateFormOrElement: (form: HTMLFormElement | HTMLInputElement): boolean => {
      if (form.checkValidity() === false) {
        form.reportValidity();
        return false;
      }
      return true;
    },
    ensureConfigColumns: function () {
      if (!this.config.columns) {
        throw new Error('SmartTable: No Columns found in Config!');
      }
    }
  }
});
